/**
 * The story piece: About us / Our story, the studio's own story in its
 * paragraphs. Carries the home's #about. Draws nothing when the studio wrote no story.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'story',
  description: "The studio's story in its own paragraphs, under About us / Our story. Drops out when there is no story.",
  placeable: true,
  options: {
    eyebrow: { type: 'string', default: 'About us', maxLength: 60, description: 'The small label above the heading; null for none.' },
    heading: { type: 'string', default: 'Our story', maxLength: 80, description: 'The section heading; null for none.' },
  },
  parts: {
    section: { description: 'The whole section.', required: false },
    eyebrow: { description: 'The small label above the heading.', required: false },
    heading: { description: 'The section heading.', required: false, role: 'title' },
    text: { description: 'The story.', required: false },
    paragraph: { description: 'One paragraph of the story.', required: false },
  },
  actions: {},
  events: {},
});

/** What the story piece knows. */
export interface StoryState {
  /** loading until the studio's profile is known; error when it failed. */
  readonly status: 'loading' | 'ready' | 'error';
  /** The story's paragraphs, split on a blank line; empty when there is no story (the section drops out). */
  readonly paragraphs: readonly string[];
}

/** The story piece has no actions. */
export type StoryActions = Record<string, never>;

/** The story piece tells its host nothing. */
export type StoryEvents = Record<string, never>;
